import { html, nothing } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import { AnnotationTool, Dropdown, MenuItem, dom } from '@omegagrid/core';
import { msg } from '@omegagrid/localize';
import rp from '@reporting/rp-app-host';
import { AppComponent } from '../component';
import { style, helpMenuContentStyle } from './helpMenu.style';
import { AccountingRights, GlobalRights } from '@reporting/rp-types/core';
import { Message as WikiMsg, Page as WikiPage } from '@reporting/rp-types/wiki';

const BUGS_URL = 'https://dev.azure.com/reporting-cz/reporting/_dashboards/dashboard/31c487b4-5386-4ceb-b22e-b4920654c33c';
const REPORT_BUG_URL = 'https://dev.azure.com/reporting-cz/9b8c8625-33e4-4fd1-a669-1053b9098df5/_workitems/create/Bug?templateId=967d6a9b-70fc-4265-8af0-9a140fb90053&ownerId=07004351-800d-4299-be36-8625a5210b53';
const REQUEST_FEATURE_URL = 'https://dev.azure.com/reporting-cz/9b8c8625-33e4-4fd1-a669-1053b9098df5/_workitems/create/Feature?templateId=04019c3e-4948-41f5-82b5-ce754ca07078&ownerId=07004351-800d-4299-be36-8625a5210b53';

const RP_LOGO_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 260 80" width="120" height="37"><g transform="matrix(0.66463275,0,0,0.66463275,-0.80549065,106.51516)"><g transform="matrix(1.3333333,0,0,-1.3333333,47.126295,-83.281579)"><path style="fill:#5ec7d1;fill-rule:nonzero;stroke:none" d="m 0,0 -8.658,4.999 8.656,4.804 8.658,-4.805 z m -9.934,17.336 8.653,4.996 V 12.124 L -9.934,7.321 Z M 9.934,7.319 1.254,12.137 v 10.21 l 8.68,-5.011 z M 0,37.496 -22.321,24.609 V -1.165 L 0,-14.051 22.32,-1.165 v 25.774 z"/></g><g transform="matrix(1.3333333,0,0,-1.3333333,356.72655,-83.282249)"><path style="fill:#4d4c4e;fill-rule:nonzero;stroke:none" d="m 0,0 10.938,13.753 c 0.65,0.83 1.408,1.661 1.408,1.661 v 0.072 c 0,0 -0.649,-0.072 -1.84,-0.072 H 0.471 v 1.408 H 14.404 V 15.594 L 3.43,1.841 C 2.779,1.011 1.986,0.18 1.986,0.18 V 0.108 c 0,0 0.686,0.072 1.877,0.072 H 14.801 V -1.227 H 0 Z m -9.943,17.255 c 4.295,0 6.461,-2.563 6.461,-2.563 l -0.94,-1.227 c 0,0 -2.057,2.31 -5.521,2.31 -4.225,0 -7.727,-3.141 -7.727,-8.014 0,-4.801 3.502,-7.942 7.727,-7.942 3.968,0 6.027,2.599 6.027,2.599 l 0.795,-1.263 c 0,0 -2.348,-2.816 -6.822,-2.816 -5.092,0 -9.315,3.682 -9.315,9.422 0,5.739 4.295,9.494 9.315,9.494 M -23.156,1.047 h 2.201 v -2.274 h -2.201 z m -9.535,7.544 c 0,3.285 -1.733,4.007 -3.61,4.007 -2.203,0 -3.322,-1.588 -3.322,-3.718 0,-2.31 1.084,-4.368 3.574,-4.368 1.625,0 3.358,0.831 3.358,4.079 M -37.133,-3.61 c 2.238,0 4.297,0.831 4.297,3.574 v 0.614 c 0,0.216 0.035,0.685 0.035,0.685 h -0.072 c -1.082,-1.299 -2.49,-1.949 -4.656,-1.949 -5.596,0 -8.375,4.584 -8.375,9.35 0,4.728 2.707,9.132 8.34,9.132 3.392,0 5.052,-1.805 5.052,-1.805 h 0.11 c 0,0 -0.037,0.217 -0.037,0.434 v 0.938 h 5.847 V 0.469 c 0,-6.786 -5.191,-9.277 -10.281,-9.277 -2.492,0 -5.234,0.722 -7.039,1.661 l 1.545,4.729 c 0,0 2.31,-1.192 5.234,-1.192 m -29.685,20.973 h 5.992 v -1.624 c 0,-0.614 -0.072,-1.156 -0.072,-1.156 h 0.072 c 0.865,1.444 2.635,3.213 5.92,3.213 3.754,0 6.677,-1.732 6.677,-6.966 V -1.227 h -6.244 V 9.674 c 0,1.733 -0.685,2.455 -2.058,2.455 -1.949,0 -3.141,-1.083 -3.682,-2.671 -0.252,-0.722 -0.361,-1.552 -0.361,-2.455 v -8.23 h -6.244 z m -9.748,7.256 h 6.101 l 0.008,-4.91 h -6.1 z m -0.063,-7.256 h 6.244 V -1.228 h -6.244 z m -13.668,-5.198 h -2.383 v 4.873 h 2.565 v 5.343 h 6.064 v -5.343 h 3.899 v -4.873 h -3.899 V 6.462 c 0,-2.094 2.129,-2.383 3.321,-2.383 0.505,0 0.83,0.036 0.83,0.036 v -5.414 c 0,0 -0.686,-0.109 -1.696,-0.109 -2.961,0 -8.701,0.794 -8.701,7.039 z m -18.135,5.198 h 5.993 v -3.14 c 0,-0.614 -0.073,-1.155 -0.073,-1.155 h 0.073 c 0.794,2.526 3.14,4.62 5.919,4.62 0.362,0 0.723,-0.072 0.723,-0.072 v -6.137 c 0,0 -0.506,0.108 -1.264,0.108 -1.48,0 -3.898,-0.469 -4.8,-3.248 -0.217,-0.686 -0.325,-1.516 -0.325,-2.527 v -7.039 h -6.246 z M -121.613,3.538 c 2.273,0 4.222,1.696 4.222,4.476 0,2.816 -1.949,4.584 -4.222,4.584 -2.274,0 -4.224,-1.768 -4.224,-4.584 0,-2.78 1.95,-4.476 4.224,-4.476 m -0.036,14.258 c 5.883,0 10.577,-3.934 10.577,-9.782 0,-5.812 -4.694,-9.675 -10.541,-9.675 -5.848,0 -10.541,3.863 -10.541,9.675 0,5.848 4.693,9.782 10.505,9.782 M -144.233,3.501 c 1.95,0 3.645,1.589 3.645,4.441 0,2.779 -1.479,4.584 -3.645,4.584 -1.877,0 -3.646,-1.372 -3.646,-4.584 0,-2.238 1.192,-4.441 3.646,-4.441 m -9.71,13.862 h 5.631 v -0.938 c 0,-0.614 -0.073,-1.192 -0.073,-1.192 h 0.073 c 0,0 1.697,2.563 5.63,2.563 5.055,0 8.375,-3.97 8.375,-9.746 0,-5.884 -3.717,-9.711 -8.663,-9.711 -3.032,0 -4.729,1.769 -4.729,1.769 h -0.072 c 0,0 0.072,-0.65 0.072,-1.588 v -6.967 h -6.244 z m -9.245,-6.894 c 0,1.407 -0.975,2.671 -2.455,2.671 -1.805,0 -2.671,-1.299 -2.996,-2.671 z m -2.311,7.364 c 5.487,0 8.591,-3.827 8.591,-8.989 0,-0.613 -0.144,-1.949 -0.144,-1.949 h -11.731 c 0.469,-2.274 2.346,-3.321 4.331,-3.321 2.671,0 5.126,1.877 5.126,1.877 l 2.31,-4.368 c 0,0 -2.996,-2.707 -7.941,-2.707 -6.643,0 -10.216,4.801 -10.216,9.747 0,5.45 3.682,9.71 9.674,9.71 m -21.702,-4.909 c 2.021,0 3.284,1.118 3.284,3.176 0,1.949 -0.722,3.105 -3.898,3.105 h -2.13 v -6.281 z m -9.061,11.695 h 8.989 c 2.634,0 3.898,-0.18 5.017,-0.614 2.924,-1.118 4.765,-3.754 4.765,-7.508 0,-2.743 -1.3,-5.739 -3.863,-7.039 V 9.386 c 0,0 0.362,-0.469 0.975,-1.553 l 5.018,-9.024 h -7.039 l -4.585,8.7 h -2.96 v -8.7 h -6.317 z"/></g></g></svg>`;
const ANNOTATION_COLORS = ['#007AFF', '#34C759', '#FF9500', '#AF52DE', '#FF3B30', '#03d1d1', '#515151', '#FFD700', '#FF69B4', '#8B4513'];

@customElement('rp-app-helpmenu')
export class HelpMenu extends AppComponent {

	static styles = style;

	@query('.bar')
	bar: HTMLDivElement;

	@query('og-dropdown')
	dropdown: Dropdown;

	/** the items without the dropdown: the compact user menu shows them in a dialog (see UserMenu), the header is too narrow for the button */
	@property({type: Boolean, reflect: true})
	inline = false;

	@state()
	news: WikiMsg[] = [];

	private dialogSize: { w: number, h: number } = { w: 800, h: 600 };

	connectedCallback() {
		super.connectedCallback();
		this.processNews();
	}

	async firstUpdated() {
		if (!this.dropdown) return;
		// fix dropdown style
		await this.dropdown.updateComplete;
		const btn = (this.dropdown.shadowRoot.querySelector('og-button') as HTMLElement);
		btn.style.border = 'none';
		btn.style.padding = '0';
	}

	async processNews() {
		this.news = await rp.ms('wiki').get<WikiMsg[]>('messages/mine', {
			accounting: 0,
			lang: rp.userProvider?.user?.lang
		});
		this.news.filter(m => !m.visited).forEach(async m => {
			await this._openNewsDialog(m);
			await rp.ms('wiki').patch(`messages/${m.id_wiki_page}/visit`, null, { accounting: m.accounting });
			m.visited = true;
		});
	}

	getNewsMenuItems() {
		const items: MenuItem[] = [];
		this.news.forEach(m => {
			items.push({
				key: `wiki-page-${m.accounting}-${m.id_wiki_page}`,
				value: m.name.split('/').pop(),
				icon: 'page',
				exec: () => { this.close(); this._openNewsDialog(m); },
			});
		});
		return items;
	}

	/** closes the menu once an item was used: the dropdown, or inline the dialog around it (`helpmenu.close`, see UserMenu) */
	close() {
		if (this.dropdown) this.dropdown.close();
		else this.dispatchEvent(new Event('helpmenu.close'));
	}

	_openWiki() {
		this.close();
		rp.host?.openSidebarComponent('wiki')
		rp.ms('wiki').get<WikiPage[]>('pages', {
			accounting: 0,
			fields: ['id_wiki_page'],
			where: { 'main_page': 1, 'lang': rp.userProvider?.user?.lang ?? 'en' },
			order: [['name', 'asc']],
			count: 1,
		}).then(pages => {
			const p = pages[0];
			if (p?.id_wiki_page) rp.host?.open(`wiki-page-0-${p.id_wiki_page}`, { title: msg('Documentation') });
		});
	}

	async _openNewsDialog(m: WikiMsg) {

		const component = await rp.host.createComponent(`wiki-page-${m.accounting}-${m.id_wiki_page}`);
		rp.host.openDialog({
			component: component,
			caption: m.name,
			closable: true,
			location: 'center',
			width: this.dialogSize.w,
			height: this.dialogSize.h,
		})
	}

	/** the latest alerts (see AlertHistory): a message the user missed in the corner is still here */
	_openAlertHistory() {
		this.close();
		rp.host.openDialog({
			component: dom.createElement('rp-app-alert-history'),
			caption: msg('Notifications'),
			closable: true,
			resizable: true,
			scrollable: true,
			location: 'center',
			width: Math.min(520, rp.host.offsetWidth - 20),
			height: Math.min(560, rp.host.offsetHeight - 20),
		});
	}

	_openAnnotationTool() {
		if (!document.querySelector('og-annotation-tool')) {
			this.close();
			const tool = dom.createElement<AnnotationTool>('og-annotation-tool', {
				logoSvg: RP_LOGO_SVG,
				colors: ANNOTATION_COLORS,
			});
			document.body.appendChild(tool);
		} else {
			rp.host.showAlert({ content: msg('Annotation Tool is already active'), type: 'info' });
		}
	}

	renderItems = () => html`
		<style>${helpMenuContentStyle}</style>

		<og-button
			@click="${() => this._openAlertHistory()}"
			color="transparent">
			<div slot="content">
				<og-icon icon="bell"></og-icon><span>${msg('Notifications')}</span>
			</div>
		</og-button>

		<og-button
			@click="${() => this._openWiki()}"
			color="transparent">
			<div slot="content">
				<og-icon icon="book"></og-icon><span>${msg('Documentation')}</span>
			</div>
		</og-button>

		${this.news.length === 0 ? nothing : this.news.length === 1 ? html`
			<og-button
				@click="${() => { this.close(); this._openNewsDialog(this.news[0]); }}"
				color="transparent">
				<div slot="content">
					<og-icon icon="newspaper"></og-icon><span>${msg('News')}</span>
				</div>
			</og-button>
		` : html`
			<og-dropdown-menu
				noCaret
				dynamicWidth
				alignment="right"
				color="transparent"
				.items="${this.getNewsMenuItems()}">
				<div slot="label">
					<og-icon icon="newspaper"></og-icon><span>${msg('News')}</span>
				</div>
			</og-dropdown-menu>
		`}

		${rp.userProvider?.hasRight(AccountingRights.Helpdesk) ? html`
			<og-button
				@click="${() => { this.close(); rp.host?.openSidebarComponent('helpdesk'); }}"
				color="transparent">
				<div slot="content">
					<og-icon icon="headset"></og-icon><span>${msg('Support')}</span>
				</div>
			</og-button>
		` : nothing}

		<og-button
			@click="${() => this._openAnnotationTool()}"
			color="transparent">
			<div slot="content">
				<og-icon icon="pen-paintbrush"></og-icon><span>${msg('Annotation')}</span>
			</div>
		</og-button>

		${rp.userProvider?.hasRight(GlobalRights.SA) ? html`
			<div class="section">
				<span class="section-label">SA Info</span>
				<div class="section-info">
					<span title="App Server: ${rp.accountingProvider.accounting?.app_server_name ?? '-'}">
						<og-icon icon="browser"></og-icon> ${rp.accountingProvider.accounting?.app_server_name ?? '-'}
					</span>
					<span title="DB Server: ${rp.accountingProvider.accounting?.db_server_name ?? '-'}">
						<og-icon icon="database"></og-icon> ${rp.accountingProvider.accounting?.db_server_name ?? '-'}
					</span>
					<span title="Version: ${rp.meta?.package?.version ?? '-'}">
						<og-icon icon="info-circle"></og-icon> ${rp.meta?.package?.version ?? '-'}
					</span>
				</div>
			</div>
		` : nothing}

		${rp.userProvider?.hasRight(GlobalRights.SA) ? html`
			<div class="section">
				<span class="section-label">SA Tools</span>
				<og-button
					@click="${() => window.open(BUGS_URL)}"
					color="transparent"
					title="${msg('Known Issues')}">
					<div slot="content"><og-icon icon="bugs"></og-icon></div>
				</og-button>
				<og-button
					@click="${() => window.open(REPORT_BUG_URL)}"
					color="transparent"
					title="${msg('Report a Bug')}">
					<div slot="content"><og-icon icon="bug"></og-icon></div>
				</og-button>
				<og-button
					@click="${() => window.open(REQUEST_FEATURE_URL)}"
					color="transparent"
					title="${msg('Request a Feature')}">
					<div slot="content"><og-icon icon="trophy"></og-icon></div>
				</og-button>
			</div>
		` : nothing}
	`;

	render = () => this.inline ? html`
		<div class="helpmenu-content">${this.renderItems()}</div>
	` : html`
		<og-dropdown
			color="transparent"
			@dropdown.open="${() => this.layout()}"
			nocaret>

			<div slot="label">
				<og-icon icon="question-circle"></og-icon>
			</div>

			<div slot="content" class="helpmenu-content">${this.renderItems()}</div>
		</og-dropdown>
	`;

}
